import { render } from "./OuterInputConfirm.vue?vue&type=template&id=4cdb4bd8&scoped=true&ts=true"
import script from "./OuterInputConfirm.vue?vue&type=script&lang=ts"
export * from "./OuterInputConfirm.vue?vue&type=script&lang=ts"

import "./OuterInputConfirm.vue?vue&type=style&index=0&id=4cdb4bd8&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cdb4bd8"]])

export default __exports__